import { IonSkeletonText } from "@ionic/react";
import React from "react";

/**
 * @author
 * E45597 Aryamitra Chaudhuri
 */

const Skeleton__Positions: React.FC = () => {
  return (
    <div style={{ margin: "8px" }}>
      <IonSkeletonText
        animated={true}
        style={{ width: "100%", height: "70px" }}
      ></IonSkeletonText>
      <IonSkeletonText
        animated={true}
        style={{ width: "100%", height: "70px" }}
      ></IonSkeletonText>
      <IonSkeletonText
        animated={true}
        style={{ width: "100%", height: "70px" }}
      ></IonSkeletonText>
      <IonSkeletonText
        animated={true}
        style={{ width: "100%", height: "70px" }}
      ></IonSkeletonText>
      <IonSkeletonText
        animated={true}
        style={{ width: "100%", height: "70px" }}
      ></IonSkeletonText>
    </div>
  );
};

export default Skeleton__Positions;
